import { AppLevel } from './types'

const APP_LEVEL_MAP: Record<string, string> = {
  preferred: 'prechecked',
  regular: 'popular',
}

export const getBIAnswer = <
  C extends { optionKey: string; biSlug: string },
  P extends { optionKey: string; level: AppLevel },
>(
  contentApps: C[],
  apps: P[],
  values: string[],
) => {
  return contentApps.reduce<Record<string, string>>((acc, contentApp) => {
    const enabled = values.includes(contentApp.optionKey)
    const level = apps.find(app => app.optionKey === contentApp.optionKey)?.level
    const mappedLevel = (level && APP_LEVEL_MAP[level]) || level

    return { ...acc, [contentApp.biSlug]: `${enabled} (${mappedLevel})` }
  }, {})
}

export const getBIAppInstallation = <P extends { optionKey: string; appDefId: string; level: AppLevel }>(
  apps: P[],
  values: string[],
) => {
  const builtInAppId = values
    .map(optionKey => {
      const app = apps.find(a => a.optionKey === optionKey)
      return app?.level === 'built-in' && app?.appDefId
    })
    .filter(Boolean)
    .join(',')

  const appId = values
    .map(optionKey => {
      const app = apps.find(a => a.optionKey === optionKey)
      return app?.appDefId
    })
    .filter(Boolean)
    .join(',')

  return { appId, builtInAppId }
}
